import mstore from '@/store/meeting-store'

const isDebug = process.env.NODE_ENV !== 'production'
const lifetimeMs = 5 * 60 * 1000

function getSendTime () {
  var date = new Date()
  var sendTime = date.getFullYear() + '/'
  sendTime += ('0' + (date.getMonth() + 1)).slice(-2) + '/'
  sendTime += ('0' + date.getDate()).slice(-2) + ' '
  sendTime += ('0' + date.getHours()).slice(-2) + ':'
  sendTime += ('0' + date.getMinutes()).slice(-2) + ':'
  sendTime += ('0' + date.getSeconds()).slice(-2) + '.'
  sendTime += ('00' + date.getMilliseconds()).slice(-3)
  return sendTime
}

export default {
  sendClickEvent: (id, that, addParam = null) => {
    if (mstore.getters.meetingSession) {
      let signalingData = {
        'event': 'click',
        'current_path': that.$route.path,
        'id': id,
        'sendTimestamp': getSendTime(),
        'sendTimestampMs': Date.now()
      }

      if (addParam) {
        Object.assign(signalingData, addParam)
      }

      if (isDebug) {
        console.log(signalingData)
      }

      mstore.getters.meetingSession.audioVideo.realtimeSendDataMessage('links-meeting-topic', JSON.stringify(signalingData), lifetimeMs)
    }
  },
  sendApiEvent: (apiName, that, data) => {
    if (mstore.getters.meetingSession) {
      let signalingData = {
        'event': 'api',
        'api': apiName,
        'current_path': that.$route.path,
        'data': data,
        'sendTimestamp': getSendTime(),
        'sendTimestampMs': Date.now()
      }

      if (isDebug) {
        console.log(signalingData)
      }

      mstore.getters.meetingSession.audioVideo.realtimeSendDataMessage('links-meeting-topic', JSON.stringify(signalingData), lifetimeMs)
    }
  },
  sendInputEvent: (that, data) => {
    if (mstore.getters.meetingSession) {
      let signalingData = {
        'event': 'input',
        'current_path': that.$route.path,
        'data': data,
        'sendTimestamp': getSendTime(),
        'sendTimestampMs': Date.now()
      }

      if (isDebug) {
        console.log(signalingData)
      }

      mstore.getters.meetingSession.audioVideo.realtimeSendDataMessage('links-meeting-topic', JSON.stringify(signalingData), lifetimeMs)
    }
  },
  sendTextEvent: (id, that, text) => {
    if (mstore.getters.meetingSession) {
      let signalingData = {
        'event': 'text',
        'current_path': that.$route.path,
        'id': id,
        'data': text,
        'sendTimestamp': getSendTime(),
        'sendTimestampMs': Date.now()
      }

      if (isDebug) {
        console.log(signalingData)
      }

      mstore.getters.meetingSession.audioVideo.realtimeSendDataMessage('links-meeting-topic', JSON.stringify(signalingData), lifetimeMs)
    }
  },
  sendDrawEvent: (data) => {
    if (mstore.getters.meetingSession) {
      let signalingData = {
        'event': 'draw',
        'data': data,
        'sendTimestamp': getSendTime(),
        'sendTimestampMs': Date.now()
      }
      mstore.getters.meetingSession.audioVideo.realtimeSendDataMessage('links-meeting-topic', JSON.stringify(signalingData), lifetimeMs)
    }
  },
  sendStatusEvent: (data) => {
    if (mstore.getters.meetingSession) {
      let signalingData = {
        'event': 'status',
        'data': data,
        'sendTimestamp': getSendTime(),
        'sendTimestampMs': Date.now()
      }
      mstore.getters.meetingSession.audioVideo.realtimeSendDataMessage('links-meeting-topic', JSON.stringify(signalingData), lifetimeMs)
    }
  },
  sendAgainEvent: (data = null) => {
    if (mstore.getters.meetingSession) {
      let signalingData = {
        'event': 'again',
        'data': data,
        'sendTimestamp': getSendTime(),
        'sendTimestampMs': Date.now()
      }
      mstore.getters.meetingSession.audioVideo.realtimeSendDataMessage('links-meeting-topic', JSON.stringify(signalingData))
    }
  }
}
